module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="modal-dialog modal-lg" role="document">\n    <div class="modal-content">\n        <div class="modal-header">\n            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n            <h4 class="modal-title" id="myModalLabel">'+
((__t=( title ))==null?'':__t)+
'</h4>\n        </div>\n        <div class="modal-body">\n            <img src="'+
((__t=( url ))==null?'':__t)+
'">\n        </div>\n    </div>\n</div>\n';
}
return __p;
};
